$(document).ready(function() {
    /* Favorites */
    $('.pos__like').on('click', function(e) {
        var favorID = $(this).attr('data-id');
        if($(this).hasClass('pos__like-active'))
            var doAction = 'delete';
        else
            var doAction = 'add';



        addFavorite(favorID, doAction);
    });
    /* Favorites */
});
/* Избранное */
    function addFavorite(id, action)
    {
        var param = 'id='+id+"&action="+action;
        $.ajax({
            url:     '/local/templates/taganrogotoplenie/ajax/favorites.php', 
            type:     "POST",
            dataType: "html",
            data: param,
            success: function(response) { // Если Данные отправлены успешно  

                var result = $.parseJSON(response);
                console.log(response);
                if(result == 1){ 
                     $('.pos__like[data-id="'+id+'"]').addClass('pos__like-active');
                } 
                if(result == 2){ 
                     $('.pos__like[data-id="'+id+'"]').removeClass('pos__like-active');
                }
                if(result == 3){ 
                    $('.header__link[data-target="#auth"]').click();
               }                 
            },
            error: function(jqXHR, textStatus, errorThrown){ // Ошибка 
                console.log(jqXHR);
            } 
         });
    }
